export const enum SERIES_TYPE {
  companySize = 'company_size',
  cities = 'cities',
  counties = 'counties',
  industries = 'industries',
}
